import React from 'react'
import { Stack, Link } from '@mui/material'
import Text from '@/components/Text'
import { UserVerificationInfo } from '@/types'
import menu_icon_black from '@/asset/img/menu_icon_black.webp'
import { ImageIcon, CheckCircleFilled } from '@/icon'
import { infoText, primary } from '@/constant'

export interface StatusCardProps {
  onClick: () => void;
  info: UserVerificationInfo;
}

const StatusCard: React.FC<StatusCardProps> = (props) => {
  const { onClick, info } = props

  return (
    <>
      <Stack sx={{ gap: '8px', flex: 1 }}>
        <Text>认证内容</Text>
        <Text size="xs" weight="thin">
          真实姓名：{info?.cert_name}
        </Text>
        <Text size="xs" weight="thin">
          证件号码：{info?.cert_no}
        </Text>
      </Stack>
      <Stack sx={{ gap: '8px', alignItems: 'stretch', flex: 1 }}>
        <Text>认证内容</Text>
        <Text size="xs" weight="thin">
          提交时间：{info?.create_at}
        </Text>
      </Stack>
      <Stack sx={{ gap: '8px', flex: 1 }}>
        <Text>
          状态
          {info?.certify_status === 2 && (
            <Link sx={{ marginLeft: '8px' }} underline="none" onClick={onClick}>
              重新认证
            </Link>
          )}
        </Text>
        {info?.certify_status === 2 && (
          <Text size="xs" sx={{ color: infoText }}>
            <ImageIcon
              src={menu_icon_black}
              sx={{ display: 'inline-flex', marginRight: '4px' }}
            />
            未完成认证，请重新填写信息，完成人脸识别
          </Text>
        )}
        {info?.certify_status === 1 && (
          <Text
            size="xs"
            sx={{ color: primary, display: 'flex', align: 'center' }}
          >
            <CheckCircleFilled />
            已完成
          </Text>
        )}
      </Stack>
    </>
  )
}

export default StatusCard
